import { apiFetch, apiUrl, isSuccess } from "./apiClient";
import { getPlatform } from "./pageViewTrackingUtils";

export async function postUserActivityToRDS(link, { pageTitle = "" } = {}) {
  const params = {
    url: encodeURI(link),
    platform: getPlatform(),
    page_title: pageTitle,
  };
  try {
    const response = await apiFetch(
      apiUrl("/userActivity/postUserActivityV2"),
      { option: "POST", body: params },
    );
    if (isSuccess(response)) {
      return await response.json();
    }
    if (response.status === 401 || response.status === 403) {
      // Silently return null for auth errors
      return null;
    }
    throw new Error(`Failed to post user activity to RDS: ${response.status}`);
  } catch (error) {
    // Silently catch errors during logout/unauthenticated state
    console.error("User activity error:", error);
    return null;
  }
}

export async function getUserPageViews(limit = 10) {
  const response = await apiFetch(
    apiUrl(`/userActivity/pageViews?limit=${limit}`),
  );
  if (isSuccess(response)) {
    return response.json();
  }
  throw new Error(`Failed to get page views: ${response.status}`);
}
